import React from 'react';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <main>
      <ContactSection />
    </main>
  );
};

export default ContactPage; 